import ReactDOM from 'react-dom';
import Countdown from 'react-countdown';
import React from "react";

function MyCountdown() {
    const Completionist = () => <span>You are good to go!</span>;

    // Renderer callback with condition
    const renderer = ({ days, hours, minutes, seconds, completed }) => {
        if (completed) {
            // Render a completed state
            return <Completionist />;
        } else {
            // Render a countdown
            return (
                <div className="flex countdown-block gap-4 mb-4 xl:mb-6">
                    <div className="flex items-start gap-2">
                        <div className="text-center">
                            <div className="text-[26px] font-bold leading-none lg:text-[42px]">
                                {days}
                            </div>
                            <div className='text-sm uppercase '>Днів</div>
                        </div>

                        <div className="text-3xl font-bold">:</div>

                        <div className="text-center">
                             <div className="text-[26px] font-bold leading-none lg:text-[42px]">
                                {hours}
                            </div>
                            <div className='text-sm uppercase '>Годин</div>
                        </div>

                        <div className="text-3xl font-bold">:</div>

                        <div className="text-center">
                            <div className="text-[26px] font-bold leading-none lg:text-[42px]">
                                {minutes}
                            </div>
                            <div className='text-sm uppercase'>Хвилин</div>
                        </div>

                        <div className="text-3xl font-bold">:</div>

                        <div className="text-center">
                            <div className="text-[26px] font-bold leading-none lg:text-[42px]">
                                {seconds}
                            </div>
                            <div className='text-sm uppercase'>Секунд</div>
                        </div>
                    </div>
                </div>
            );
        }
    };

    return (
        <div className="countdown-wrap lg:flex lg:items-center lg:gap-6">
            <div className="text-sm font-medium tracking-[0.15em] uppercase mb-4
                xl:text-base xl:max-w-[127px]">
                Early birds
            </div>
            <Countdown
                date={Date.now() + (new Date('2026-10-04T23:59:59') - Date.now())}
                renderer={renderer}
            />
        </div>
    )
}

export default MyCountdown